import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'


import {applyMiddleware, compose, createStore} from 'redux'
import createHistory from 'history/createBrowserHistory'
import queryString from 'query-string'


import createSagaMiddleware from 'redux-saga'
import reducer from './reducers';
import './index.less';
import App from './App';
import ApiError from './services/ApiError';
import rootSaga from './sagas'
import Raven from 'raven-js';
import createRavenMiddleware from "raven-for-redux";

import {ConnectedRouter} from 'react-router-redux'
import {addLocaleData, IntlProvider} from "react-intl";
import translations from "./i18n/locales";
import frLocaleData from "react-intl/locale-data/fr";
import deLocaleData from "react-intl/locale-data/de";
import nlLocaleData from "react-intl/locale-data/nl";
import Constants from "./services/Constants";
import {LocaleProvider} from "antd";
import {Route, Switch} from "react-router-dom";
import Public from "./Public";
import Storage from './services/Storage'


// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

Raven.config('https://a11493fb43a8445fa20cb6bc97382c39@sentry.io/1246240').install()

const sagaMiddleware = createSagaMiddleware({onError: (error)=>{
  Raven.captureException(error);
  }})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const user = Storage.getSessionItem('user');
const context = Storage.getSessionItem('context') || {};
const persistedState = {
   authentication: {
     userState: (!!user) ? 'signed-in' : null,
   },
   publicContext: {
     ...context.publicContext
   }
};

const middleware = [ createRavenMiddleware(Raven), sagaMiddleware, ApiError];

const store = createStore(reducer,  persistedState,  composeEnhancers(

  applyMiddleware(...middleware)
));

sagaMiddleware.run(rootSaga)

addLocaleData(frLocaleData);
addLocaleData(deLocaleData);
addLocaleData(nlLocaleData);

const params = queryString.parse(window.location.search);
let locale = params.locale || Storage.getItem('lg') || navigator.language || navigator.userLanguage || "en";
if (locale.length > 2){
  locale = locale.substr(0, 2);
}
Storage.setItem('lg', locale);
const messages = translations[locale];

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <LocaleProvider locale={Constants.LOCALES[locale]}>

        <ConnectedRouter history={history}>
          <Switch>
            <Route path='/public/' component={Public}/>
            <Route component={App}/>
          </Switch>

        </ConnectedRouter>
      </LocaleProvider>
    </IntlProvider>
  </Provider>,
  document.getElementById('root')
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js